export enum UserRoles {
  MEMBER = "Member",
  ADMIN = "Admin",
  STAFF = "Staff",
}
